import React, {useContext} from "react";
import {AuthContext, getLoggedInUser} from "contexts/auth/auth.provider";
import {useFormik} from "formik";
import BlockUi from "react-block-ui";
import {useRouter} from "next/router";
import {Logo} from "components/logos";
import notifications from "utils/notifications";
import {Google} from "components/Icons";

const IndexPage = () => {
    const router = useRouter();
    const {login, loading, federatedSignIn} = useContext<any>(AuthContext);

    const handleLogin = (values) => {
        const {email, password} = values;
        login(email, password)
            .then((user) => {
                notifications.success(`Welcome ${user.attributes?.given_name || ''}`, null, 5000);
                router.push((router.query?.r as string)?.replace("/rent", "") || "/camping");
            }).catch((e) => {
            notifications.error(e.message);
        });
    };


    const {getFieldProps, handleSubmit} = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        onSubmit: handleLogin,
    });

    function onFederated(provider) {
        federatedSignIn({
            provider,
            customState: {
                a: 1
            }
        }).then((user) => {
            notifications.success(`Welcome ${user?.attributes?.given_name || ''}`, null, 5000);
            router.push((router.query?.r as string)?.replace("/rent", "") || "/camping");
        })
            .catch(e => notifications.error(e.message))
    }

    return (
        <div
            className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <a href="/">
                    <Logo
                        className="mx-auto h-20 w-auto"
                    />
                </a>
                <h2 className="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900">
                    Sign in to your account
                </h2>
                <p className="mt-2 text-center text-sm leading-5 text-gray-600 max-w">
                    Or&nbsp;
                    <a
                        href="/rent/auth/signup"
                        className="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150"
                    >
                        sign up here
                    </a>
                </p>
            </div>
            <BlockUi tag={"div"} blocking={loading} className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <form onSubmit={handleSubmit}>


                        <div>
                            <label
                                htmlFor="email"
                                className="block text-sm font-medium leading-5 text-gray-700"
                            >
                                Email address
                            </label>
                            <div className="mt-1 rounded-md shadow-sm">
                                <input
                                    {...getFieldProps('email')}
                                    id="email"
                                    type="email"
                                    required
                                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                />
                            </div>
                        </div>
                        <div className="mt-6">
                            <label
                                htmlFor="password"
                                className="block text-sm font-medium leading-5 text-gray-700"
                            >
                                Password
                            </label>
                            <div className="mt-1 rounded-md shadow-sm">
                                <input
                                    {...getFieldProps('password')}
                                    id="password"
                                    type="password"
                                    required
                                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                />
                            </div>
                        </div>
                        <div className="mt-6 flex items-center justify-between">
                            <div className="text-sm leading-5">
                                <a
                                    href="/rent/auth/reset-password"
                                    className="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150"
                                >
                                    Forgot your password?
                                </a>
                            </div>
                        </div>
                        <div className="mt-6">
          <span className="block w-full rounded-md shadow-sm">
            <button
                type="submit"
                className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
            >
              Sign in
            </button>
          </span>
                        </div>
                    </form>
                    <div className="mt-6">
                        <div className="relative">
                            <div className="absolute inset-0 flex items-center">
                                <div className="w-full border-t border-gray-300"/>
                            </div>
                            <div className="relative flex justify-center text-sm leading-5">
            <span className="px-2 bg-white text-gray-500">
              Or continue with
            </span>
                            </div>
                        </div>
                        <div className="mt-6 grid grid-cols-2 gap-3">
                            <div>
                                <span className="w-full inline-flex rounded-md shadow-sm">
                                  <button
                                      onClick={(e) => {
                                          e.preventDefault();
                                          onFederated('Facebook');
                                      }}
                                      className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out"
                                      aria-label="Sign in with Facebook"
                                  >
                                    <svg
                                        className="w-5 h-5"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                    >
                                      <path
                                          fillRule="evenodd"
                                          d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z"
                                          clipRule="evenodd"
                                      />
                                    </svg>
                                  </button>
                                </span>
                            </div>

                            <div>
                                <span className="w-full inline-flex rounded-md shadow-sm">
                                  <button
                                      onClick={(e) => {
                                          e.preventDefault();
                                          onFederated('Google');
                                      }}
                                      className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out"
                                      aria-label="Sign in with Google"
                                  >
                                    <Google/>
                                  </button>
                                </span>
                            </div>


                        </div>
                    </div>
                </div>
            </BlockUi>
        </div>

    )
}

export async function getServerSideProps(context) {
    const user = await getLoggedInUser(context);
    if (user) {
        if (context.res) {
            const redirect = `/rent/camping`;
            context.res.writeHead(302, {Location: redirect});
            context.res.end()
            return {props: {}};
        }
    }

    return {props: {}};
}

export default IndexPage
